import React from 'react';
import styles from '../../cases.module.scss';
import styled from "styled-components";
import useSelectedLanguageCode from '../../../../../hooks/useSelectedLanguageCode';

const SuccessCaseDetails = ({ clientLogo, clientName, clientSegment, description, clientColor, caseImg, data }) => {
    const selectedLanguageCode = useSelectedLanguageCode();

    const StyledClientDescription = styled.p`
        b {
            color: ${clientColor}
        }
    `
    if (!clientName) {
        return <></>;
    }

    return (
        <div className={styles.successCaseDetailsContainer}>
            <img src={clientLogo} alt="Logo"></img>
            
            <div className={styles.successCaseCustomerInfoContainer}>
                <div className={styles.successCaseCustomerInfo}>
                    <h1>{clientName[selectedLanguageCode]}</h1>
                    <h4>{clientSegment[selectedLanguageCode]}</h4>
                    <StyledClientDescription dangerouslySetInnerHTML={{__html: description[selectedLanguageCode]}} />
                </div>

                <div className={styles.successCaseCustomerVideo}>
                    <img src={caseImg} alt="Video Case" />
                </div>
            </div>

            <div className={styles.successCaseCustomerDataContainer}>
                {data?.map((d, i) => (
                    <div key={i} className={styles.successCaseCustomerDataItem}>
                        <strong style={{color: clientColor}}>
                            {d.number}
                        </strong>

                        <p>{d.text[selectedLanguageCode]}</p>
                    </div>
                ))}
            </div>
        </div>
    );

};

export default SuccessCaseDetails;
